/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import degree from "assets/images/degree.png";
import DataTable from "examples/Tables/DataTable";
import { Icon } from "@mui/material";
import moment from "moment";

export default function data({ educations, isMyProfile = true }) {
  const Education = ({ image, name, startDate, endDate }) => (
    <MDBox display="flex" gap={2}>
      <MDAvatar
        src={degree}
        name={name}
        size="sm"
        sx={{
          borderRadius: 2,
          width: "45px", // optional: control size
          height: "45px", // optional: control size
          border: "2px solid",
          borderColor: "light.main",
          "& img": {
            width: "55%",
            height: "55%",
            objectFit: "contain",
            objectPosition: "center",
          },
        }}
      />
      <MDBox>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">
          {startDate} - {endDate}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const columns = () => {
    var columnsData = [{ Header: "education", accessor: "education", width: "85%", align: "left" }];
    if (isMyProfile) {
      columnsData.push({
        Header: (
          <MDBox
            component="a"
            href="#"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            width="32px"
            height="32px"
            border="2px solid"
            color="success"
            borderRadius="4px"
          >
            <Icon fontSize="medium" color="success">
              add
            </Icon>
          </MDBox>
        ),
        accessor: "action",
        width: "15%",
        align: "center",
      });
    }

    return columnsData;
  };

  const rows = () => {
    var rowsData = [];

    educations.map((edu) =>
      rowsData.push({
        education: (
          <Education
            image={team2}
            name={`${edu?.school} - ${edu?.degree} - ${edu?.stream}`}
            startDate={moment(edu?.startDate).format("DD MMM YYYY")}
            endDate={
              edu?.isCurrentStudying ? "Present" : moment(edu?.endDate).format("DD MMM YYYY")
            }
          />
        ),
        ...(isMyProfile && {
          action: (
            <MDTypography
              component="a"
              href="#"
              variant="caption"
              color="success"
              fontWeight="medium"
            >
              <Icon fontSize="small">edit</Icon>
            </MDTypography>
          ),
        }),
      })
    );

    return rowsData;
  };

  return (
    <MDBox pt={3}>
      <DataTable
        table={{ columns: columns(), rows: rows() }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
    </MDBox>
  );
}
